import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogPostPage from "@/pages/BlogPostPage";
import Projek from "@/pages/Projek";
import ProjekDetail from "@/pages/ProjekDetail";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/projek" element={<Projek />} />
          <Route path="/projek/:slug" element={<ProjekDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
